<template>
<div>

	Das Passwort muss:
	<ul>
	<li> mindestens acht Zeichen lang sein </li>
	<li> mindestens einen Buchstaben beinhalten</li>
	<li> mindestens eine Zahl beinhalten</li>
	</ul>


	<input type="password" class="form-control inputElement" v-bind:placeholder="$t('login.password')" autocomplete="off"> 
	<input type="password" class="form-control" id="password2" v-bind:placeholder="$t('login.passwordRepeat')" autocomplete="off">
	
</div>
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      output: {}
    };
  },
  props: ["value", "id"]
};
</script>

<style scoped>
.inputElement {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/input/PasswordInput.vue